import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Select, ConfigProvider } from 'antd';
import { connect } from 'react-redux';
import { selectDevice } from 'store/actions';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const DropdownDvr = ({ data, selectedDevice, selectDevice, isLoaded }) => {
	const { t } = useTranslation();
	const conditionToRunSelectDevice =
		isLoaded && data && data.length > 0 && !selectedDevice;

	/*eslint-disable */
	useEffect(() => {
		conditionToRunSelectDevice && selectDevice(data[0].id);
	}, [isLoaded]);
	/*eslint-enable */

	const handleChangeSelect = (value) => {
		const { id } = data.find((item) => item.id === value);

		selectDevice(id);
	};

	const localeOptions = {
		Empty: { description: `${t('user_profile_vod_empty')}` }
	};

	const device = selectedDevice || '';

	return (
		<Wrapper>
			<Paragraph>{t('user_profile_recordings_choose_device')}</Paragraph>
			<ConfigProvider locale={localeOptions}>
				<Select
					value={device}
					style={{ width: 200 }}
					onChange={handleChangeSelect}
				>
					{data?.map(({ id }) => (
						<Option key={id} value={id}>
							{id}
						</Option>
					))}
				</Select>
			</ConfigProvider>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	display: flex;
	justify-items: center;
`;

const Paragraph = styled.p`
	font-size: 1.4rem;
	margin-right: 0.8rem;
	padding-top: 1rem;
	color: ${({ theme: { user } }) => user.topHeadingFilter};
`;

const mapStateToProps = ({ devices: { data, selectedDevice, isLoaded } }) => ({
	data,
	selectedDevice,
	isLoaded
});

export default connect(
	mapStateToProps,
	{ selectDevice }
)(DropdownDvr);
